import type { SuggestedMessage } from '../shared/chatbot.types';
import ChatBox from './ChatBox';
import { ChatHeader } from './layout/ChatHeader';

interface WebChatProps {
  suggestions?: SuggestedMessage[];
  onClose: () => void;
  onGoBack: () => void;
  onResize: (expanded: boolean) => void;
}

export function WebChat({ suggestions, onClose, onGoBack, onResize }: WebChatProps) {
  return (
    <>
      <ChatHeader onGoBack={onGoBack} onClose={onClose} onResize={onResize} />
      <ChatBox suggestions={suggestions} />
    </>
  );
}
